import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import "./AddMember.css";

const AddMemberNotification = () => {
    const [showNotification, setShowNotification] = useState(false);
    const [showMailPopup, setShowMailPopup] = useState(false);
    const [insuranceCompanies, setInsuranceCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);

    // Fetch insurer list
    useEffect(() => {
        fetch("/api/insurance_companies")
            .then((res) => res.json())
            .then((data) => setInsuranceCompanies(Array.isArray(data) ? data : []))
            .catch((err) => console.error("fetch insurance error:", err));
    }, []);

    // Function to send mail to insurer
    const handleSendMail = async () => {
        if (!file || !selectedCompany) {
            alert("Please select an insurer and attach the Excel file before sending.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);
        formData.append("insurer_name", selectedCompany.insurer_name);
        formData.append("insurer_email", selectedCompany.insurer_email);

        setLoading(true);
        try {
            const res = await fetch("/api/sendMailToInsurer", {
                method: "POST",
                body: formData,
            });
            const result = await res.json();
            if (result.success) {
                alert("Mail sent successfully to the insurer!");
                setShowMailPopup(false);
                setShowNotification(false);
                setFile(null);
                setSelectedCompany(null);
            } else {
                alert("Failed to send mail. Please try again.");
            }
        } catch (err) {
            console.error("Mail send error:", err);
            alert("Error sending mail. Please check console for details.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Button to open Add Member Notification */}
            <button className="add-member-btn" onClick={() => setShowNotification(true)}>
                Add Members
            </button>

            {/* Notification Popup */}
            {showNotification && (
                <div className="notification-overlay">
                    <div className="notification-box">
                        <h3>Add New Members</h3>
                        <p>
                            To add a new employee, you need to send an email notification to the insurer.
                        </p>
                        <div className="notification-actions">
                            <button
                                className="btn-notify"
                                onClick={() => {
                                    setShowMailPopup(true);
                                    setShowNotification(false);
                                }}
                            >
                                Send Mail
                            </button>
                            <button
                                className="btn-cancel"
                                onClick={() => setShowNotification(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Mail Popup */}
            {showMailPopup && (
                <div className="mail-overlay">
                    <div className="mail-box">
                        <h3>Send Mail to Insurer</h3>
                        <p>Please attach the employee list Excel file for adding new members.</p>

                        <div className="mail-form">
                            <label>Insurer</label>
                            <div className="mail-insurer-select">
                                <select
                                    value={selectedCompany ? selectedCompany.id : ""}
                                    onChange={(e) =>
                                        setSelectedCompany(
                                            insuranceCompanies.find(
                                                (c) => c.id === parseInt(e.target.value)
                                            )
                                        )
                                    }
                                >
                                    <option value="">-- Select Insurer --</option>
                                    {insuranceCompanies.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.company_name}
                                        </option>
                                    ))}
                                </select>
                                <button type="button" className="mail-add-insurer-btn">
                                    <FaPlus />
                                </button>
                            </div>

                            <label>Insurer Name</label>
                            <input
                                type="text"
                                value={selectedCompany ? selectedCompany.insurer_name : ""}
                                onChange={(e) =>
                                    setSelectedCompany((prev) => ({
                                        ...prev,
                                        insurer_name: e.target.value,
                                    }))
                                }
                            />

                            <label>Insurer Email</label>
                            <input
                                type="email"
                                value={selectedCompany ? selectedCompany.insurer_email : ""}
                                onChange={(e) =>
                                    setSelectedCompany((prev) => ({
                                        ...prev,
                                        insurer_email: e.target.value,
                                    }))
                                }
                            />

                            <label>Attach Employee Excel</label>
                            <input
                                type="file"
                                accept=".xls,.xlsx"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                        </div>

                        <div className="mail-actions">
                            <button
                                className="btn-send"
                                onClick={handleSendMail}
                                disabled={loading}
                            >
                                {loading ? "Sending..." : "Send"}
                            </button>
                            <button
                                className="btn-cancel"
                                onClick={() => {
                                    setShowMailPopup(false);
                                    setFile(null);
                                    setSelectedCompany(null);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddMemberNotification;
